
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface WidgetProps {
  id: string;
  title: string;
  children: ReactNode;
  isEditMode?: boolean;
  onRemove?: (id: string) => void;
  className?: string;
}

export function Widget({
  id,
  title,
  children,
  isEditMode = false,
  onRemove,
  className,
}: WidgetProps) {
  return (
    <div
      className={cn(
        'bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden flex flex-col h-full',
        isEditMode && 'ring-2 ring-primary-500/50',
        className
      )}
    >
      {/* Widget header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {isEditMode && (
            <div className="cursor-move text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 widget-drag-handle">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
              </svg>
            </div>
          )}
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white truncate">
            {title}
          </h3>
        </div>
        {isEditMode && onRemove && (
          <button
            onClick={() => onRemove(id)}
            className="ml-2 text-slate-400 hover:text-red-600 dark:hover:text-red-400 p-1 rounded hover:bg-slate-100 dark:hover:bg-slate-700"
            title="Remove widget"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Widget content */}
      <div className="flex-1 p-4 overflow-auto">
        {children}
      </div>
    </div>
  );
}
